import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "290",
  height: "280",
  fill: "none",
  viewBox: "34 52 336 324"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"var(--color-gray-02)\"><circle cx=\"104\" cy=\"236\" r=\"58\"></circle><circle cx=\"160\" cy=\"176\" r=\"76\"></circle><circle cx=\"240\" cy=\"160\" r=\"86\"></circle><circle cx=\"306\" cy=\"236\" r=\"54\"></circle><rect width=\"314\" height=\"106\" x=\"46\" y=\"230\" rx=\"53\"></rect></g><path fill=\"var(--color-gray-16)\" d=\"M150 210h112a34 34 0 0 0-8-67 46 46 0 0 0-91 10 29 29 0 0 0-13 57\"></path><path fill=\"var(--color-gray-15)\" d=\"M118 232h118a38 38 0 0 0-8-75 52 52 0 0 0-103 11 32 32 0 0 0-7 64\"></path><path fill=\"var(--color-zinc-600)\" d=\"m186 238-22 42h20l-12 38 42-54h-22l14-26Z\"></path><path stroke=\"var(--color-gray-16)\" stroke-linecap=\"round\" stroke-width=\"6\" d=\"m132 262-8 14m108-14 8 14m-90 14-6 12m82-10 6 12\"></path>", 5)
  ]))]))
}
export default { render: render }